import { MaskInput } from "maska";

const onDomReady = (callback) => {
  if (document.readyState !== "loading") {
    return setTimeout(callback, 0);
  } else {
    return document.addEventListener("DOMContentLoaded", () => callback());
  }
};

const applyMaskOnInputs = () => {
  const maskInputs = Array.from(document.querySelectorAll("input[data-maska]"));
  return maskInputs.map((input) => new MaskInput(input));
};

onDomReady(() => {
  let minputs = applyMaskOnInputs();

  const resetMasks = () => {
    if (minputs) {
      minputs.forEach((minput) => minput.destroy());
    }
  };

  document.addEventListener("turbo:before-cache", () => {
    resetMasks();
  });
  document.addEventListener("turbo:render", () => {
    resetMasks();
    minputs = applyMaskOnInputs();
  });
});
